<div class="card dashboard-sq-banner justify-content-end">
    <div class="card-body justify-content-end d-flex flex-column">
        <ng-content></ng-content>
    </div>
</div>